import { render, staticRenderFns } from "./detail.park.vue?vue&type=template&id=70ad3346&scoped=true&"
import script from "./detail.park.vue?vue&type=script&lang=js&"
export * from "./detail.park.vue?vue&type=script&lang=js&"
import style0 from "./detail.park.vue?vue&type=style&index=0&id=70ad3346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad3346",
  null
  
)

export default component.exports